import React from "react";
import { Grid, Typography, Paper, Divider, Box } from "@mui/material";
import {
  CmpTextField,
  CmpTypographyField,
} from "../../../Component/Common/ToolBox/ToolBox";
import { useSelector } from "react-redux";

export const ItemList = ({ item }) => {
  console.log(item);
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const canViewCost = vRdxuserInfo?.UserRights?.ViewCost?.toUpperCase() == "Y";

  const fields = [
    { label: "Barcode", value: item?.Barcode || "" },
    { label: "Item Code", value: item?.ItmCd || "" },
    { label: "Item Name", value: item?.ItemName || item?.Name2 || "" },
    { label: "Unit", value: item?.Unit || "" },
    { label: "Pack Qty", value: item?.PackQty || "" },
    { label: "Packing", value: item?.Packing || "" },
    ...(canViewCost
      ? [
          { label: "Cost", value: item?.Costpr?.toFixed(3) || "" },
          { label: "Price", value: item?.SellPr1?.toFixed(3) || "" },
          { label: "Stock Val", value: item?.StkVal?.toFixed(3) || "" },
          { label: "VAT.Rsp", value: item?.VATRsp || "" },
          { label: "Promo.RSP", value: item?.PromoRSP || "" },
          { label: "Promo.VAT.RSP", value: item?.PromoVATRSP || "" },
          { label: "Vendor", value: item?.MainSupplierName || "" },
        ]
      : []),
    { label: "Stock Qty", value: item?.StkQty || "" },
  ];

  return (
    <Grid container spacing={1} marginTop={"15px"}>
      {fields?.map((field, index) => (
        <React.Fragment key={index}>
          <Grid item xs={4} md={2}>
            {/* <Typography variant="body2" style={{ fontWeight: 'bold',}}>
                {field.label}
              </Typography> */}

            <CmpTypographyField xcomponent={"span"} xText={field.label} />
          </Grid>
          <Grid item xs={8} md={10}>
            {/* <Typography variant="body2" style={{ color: '#333' }}>
                {field.value}
              </Typography> */}
            <CmpTextField
              // xLabelText={"Item Code"}
              xVariant={"standard"}
              xValue={field.value}
              xType={"text"} // text/number/password
              xName={"B_Itmcd"}
              xReadOnly={true}
              xOnChange={""}
            />
          </Grid>
          {/* {index < 8 && <Divider style={{ width: '100%', margin: '8px 0' }} />} */}
        </React.Fragment>
      ))}
    </Grid>
  );
};
